import { useMemo, useState } from "react";

import { JsonNode } from "@/components/viewer/JsonNode";
import { SearchBar } from "@/components/viewer/SearchBar";

type Props = {
  root: unknown;
  initialExpandedDepth?: number;
};

export function JsonViewer({ root, initialExpandedDepth = 1 }: Props) {
  const [query, setQuery] = useState("");

  const filtered = useMemo(() => {
    if (!query) return root;
    return filterByQuery(root, query.toLowerCase());
  }, [root, query]);

  return (
    <div className="flex flex-col gap-3">
      <SearchBar value={query} onChange={setQuery} />
      <div className="max-h-[70vh] overflow-auto rounded-[14px] border border-[var(--color-border)] bg-[var(--color-code-bg)] p-3">
        <JsonNode
          nodeKey=""
          value={filtered}
          depth={0}
          initialExpanded={initialExpandedDepth > 0}
          highlight={query}
        />
      </div>
    </div>
  );
}

function filterByQuery(node: unknown, q: string): unknown {
  if (node === null || typeof node !== "object") {
    return String(node).toLowerCase().includes(q) ? node : undefined;
  }
  if (Array.isArray(node)) {
    const kept = node.map((v) => filterByQuery(v, q)).filter((v) => v !== undefined);
    return kept.length ? kept : undefined;
  }
  const out: Record<string, unknown> = {};
  for (const [k, v] of Object.entries(node)) {
    if (k.toLowerCase().includes(q)) {
      out[k] = v;
      continue;
    }
    const kept = filterByQuery(v, q);
    if (kept !== undefined) out[k] = kept;
  }
  return Object.keys(out).length ? out : undefined;
}
